// TODO: Decide and add different alert or notification types
export enum AlertTypes {
    Maintenance = 0,
}